export default () => ({
  type: 'CLEAR_MODAL',
});
